var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinDepot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 53",
    enableBackground: "new 0 0 55 53",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Depot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Depot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 78,
    height: 74,
    xlinkHref: "7886C8EFA5D81BDA.png",
    transform: "matrix(1 0 0 1 -11.6943 -10.707)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    fill: "#192940",
    stroke: "#192940",
    strokeWidth: 2.4,
    d: "M9.822,7h34.756c2.674,0,4.822,2.104,4.822,4.722 v24.396c0,2.618-2.135,4.656-4.822,4.656H33.729c-0.312,0-0.62,0.14-0.82,0.373L27.171,47.8l-5.68-6.648 c-0.2-0.234-0.508-0.376-0.82-0.377H9.822C7.134,40.774,5,38.736,5,36.118V11.722C5,9.104,7.148,7,9.822,7z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    fill: "#FFFFFF",
    d: "M27.399,16.008c-0.067,0.013-0.132,0.038-0.191,0.073l-9.916,5.833 c-0.279,0.16-0.375,0.518-0.214,0.797c0.161,0.279,0.518,0.375,0.797,0.214l1.458-0.857v9.688c0,0.322,0.261,0.583,0.583,0.583 h15.165c0.322,0,0.584-0.261,0.584-0.583v-9.688l1.457,0.857c0.279,0.161,0.638,0.065,0.798-0.214 c0.161-0.279,0.065-0.637-0.214-0.797l-9.916-5.833C27.673,16.012,27.535,15.985,27.399,16.008L27.399,16.008z M27.5,17.266l7,4.12 v9.788H20.5v-9.788L27.5,17.266z M23.653,24.049c-0.155,0.007-0.301,0.075-0.404,0.19c-0.105,0.114-0.158,0.266-0.151,0.42 s0.075,0.301,0.19,0.404c0.114,0.105,0.266,0.159,0.42,0.152h7.583c0.156,0.002,0.307-0.059,0.418-0.168 c0.11-0.11,0.173-0.26,0.173-0.416s-0.062-0.305-0.173-0.416c-0.111-0.109-0.262-0.17-0.418-0.168h-7.583 C23.69,24.048,23.671,24.048,23.653,24.049L23.653,24.049z M23.653,26.091c-0.155,0.007-0.301,0.075-0.404,0.19 c-0.105,0.114-0.158,0.265-0.151,0.42c0.007,0.155,0.075,0.301,0.19,0.404c0.114,0.105,0.266,0.158,0.42,0.151h7.583 c0.156,0.003,0.307-0.058,0.418-0.167c0.11-0.111,0.173-0.26,0.173-0.416s-0.062-0.306-0.173-0.416 c-0.111-0.109-0.262-0.17-0.418-0.167h-7.583C23.69,26.089,23.671,26.089,23.653,26.091L23.653,26.091z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDepot);
export default __webpack_public_path__ + "static/media/pin-depot.71304a6ac91528e30bc2818b0e8469a9.svg";
export { ForwardRef as ReactComponent };